import {GET, POST} from "@/services/gateway";

const getReport = (data) => {
  return POST('report/summary', data);
}

const getOtherEventsReport = (data) => {
  return POST('report/summary/other', data);
}

const listEventLogs = (data) => {
  return POST('report/events', data);
}

const exportEventLogs = (data) => {
  const currentDate = new Date();

  return POST('report/export', {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  });
}

const listWebActivityLogs = (data) => {
  return POST('report/user-activity-log', data);
}

const exportWebActivityLogs = (data) => {
  const currentDate = new Date();

  return POST('report/export-user-activity-log', {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  });
}

const getJobDetails = (id) => {
  return GET(`report/events/${id}`,)
}

export {
  getReport,
  getOtherEventsReport,
  listEventLogs,
  exportEventLogs,
  getJobDetails,
  listWebActivityLogs,
  exportWebActivityLogs,
}
